import PageHero from "@/components/PageHero";

/**
 * Shared layout for legal pages. Takes an array of sections
 * ({ id, title, body: JSX }) and renders a sticky TOC + prose column.
 */
export default function LegalPage({ eyebrow, title, subtitle, effectiveDate, sections, testId }) {
  return (
    <div data-testid={testId}>
      <PageHero eyebrow={eyebrow} title={title} subtitle={subtitle} testId={`${testId}-hero`} />

      <section className="py-14 md:py-20">
        <div className="max-w-[1280px] mx-auto px-5 md:px-10 lg:px-14 grid md:grid-cols-12 gap-10">
          {/* Sticky TOC */}
          <aside className="md:col-span-3">
            <div className="md:sticky md:top-24">
              <div className="eyebrow mb-4">Contents</div>
              <nav className="space-y-2">
                {sections.map((s) => (
                  <a
                    key={s.id}
                    href={`#${s.id}`}
                    className="block text-sm text-[color:var(--muted)] hover:text-[color:var(--primary-dark)] transition-colors leading-snug"
                    data-testid={`${testId}-toc-${s.id}`}
                  >
                    {s.title}
                  </a>
                ))}
              </nav>
              {effectiveDate && (
                <div className="mt-8 text-xs text-[color:var(--muted)]">
                  Effective date<br />
                  <span className="text-[color:var(--primary-dark)] font-medium">{effectiveDate}</span>
                </div>
              )}
            </div>
          </aside>

          {/* Prose column */}
          <article className="md:col-span-9 prose-legal">
            {sections.map((s) => (
              <section
                key={s.id}
                id={s.id}
                className="scroll-mt-24 mb-12"
                data-testid={`${testId}-section-${s.id}`}
              >
                <h2 className="font-display text-2xl md:text-3xl text-[color:var(--primary-dark)] mb-5 leading-tight">
                  {s.title}
                </h2>
                <div className="space-y-4 text-[color:var(--primary-dark)]/85 leading-relaxed text-[15px]">
                  {s.body}
                </div>
              </section>
            ))}
          </article>
        </div>
      </section>
    </div>
  );
}
